import { Stack, Typography } from "@mui/material"
import { VeribliLogo } from "../../assets/svgs/VeribliLogo"
import { ReactElement } from "react"
import { DashboardIcon } from "../../assets/svgs/DashboardIcon"
import { UsersIcon } from "../../assets/svgs/UsersIcon"
import { CubsIcon } from "../../assets/svgs/CubsIcon"
import { TemplatesIcon } from "../../assets/svgs/TemplatesIcon"
import { PrimaryIcon } from "../../assets/svgs/PrimaryIcon"
import { AnalysisIcon } from "../../assets/svgs/AnalysisIcon"
import { ProfileInfo } from "./ProfileInfo"
import { useLocation } from "react-router-dom"
import { Link } from "../global/Link"
import { SectorIcon } from '../../assets/svgs/SectorIcon';
import { ClientIcon } from '../../assets/svgs/ClientIcon';
import { UploadIcon } from '../../assets/svgs/UploadIcon';
import { CategoryIcon } from '../../assets/svgs/CategoryIcon';
import { useGlobalAtoms } from "../../atoms/globalAtoms"
import { TagIcon } from '../../assets/svgs/TagIcon';
import { useAuth } from "../../assets/contexts/AuthContext"

type SidebarMenuItemType = {
  name: string;
  icon: ReactElement;
  selectedIcon: ReactElement;
  link: string;
}

const superAdminSidebarMenuItems: SidebarMenuItemType[] = [
  { name: 'Dashboard', icon: <DashboardIcon color="#4B5851" />, selectedIcon: <DashboardIcon color="#FFFFFF" />, link: '/'},
  { name: 'Clients', icon: <ClientIcon color="#4B5851" />, selectedIcon: <ClientIcon color="#FFFFFF" />, link: '/clients'},
  { name: 'Users', icon: <UsersIcon color="#4B5851" />, selectedIcon: <UsersIcon color="#FFFFFF" />, link: '/users'},
  { name: 'Product SKUs', icon: <CubsIcon color="#4B5851" />, selectedIcon: <CubsIcon color="#FFFFFF" />, link: '/products'},
  { name: 'Tags', icon: <TagIcon color="#4B5851" />, selectedIcon: <TagIcon color="#FFFFFF" />, link: '/tags'},
  { name: 'Engagement Pages', icon: <TemplatesIcon color="#4B5851" />, selectedIcon: <TemplatesIcon color="#FFFFFF" />, link: '/templates'},
  { name: 'Categories', icon: <CategoryIcon color="#4B5851" />, selectedIcon: <CategoryIcon color="#FFFFFF" />, link: '/categories'},
  { name: 'Sectors', icon: <SectorIcon color="#4B5851" />, selectedIcon: <SectorIcon color="#FFFFFF" />, link: '/sectors'},
  { name: 'Locations', icon: <PrimaryIcon color="#4B5851" />, selectedIcon: <PrimaryIcon color="#FFFFFF" />, link: '/bars'},
  { name: 'Upload Tags', icon: <UploadIcon color="#4B5851" />, selectedIcon: <UploadIcon color="#FFFFFF" />, link: '/upload-tags'},
  { name: 'Analytics', icon: <AnalysisIcon color="#4B5851" />, selectedIcon: <AnalysisIcon color="#FFFFFF" />, link: '/analytics'},  
];

const clientAdminSidebarMenuItems: SidebarMenuItemType[] = [
  { name: 'Dashboard', icon: <DashboardIcon color="#4B5851" />, selectedIcon: <DashboardIcon color="#FFFFFF" />, link: '/'},
  { name: 'Clients', icon: <ClientIcon color="#4B5851" />, selectedIcon: <ClientIcon color="#FFFFFF" />, link: '/clients'},
  { name: 'Product SKUs', icon: <CubsIcon color="#4B5851" />, selectedIcon: <CubsIcon color="#FFFFFF" />, link: '/products'},
  { name: 'Tags', icon: <TagIcon color="#4B5851" />, selectedIcon: <TagIcon color="#FFFFFF" />, link: '/tags'},
  { name: 'Engagement Pages', icon: <TemplatesIcon color="#4B5851" />, selectedIcon: <TemplatesIcon color="#FFFFFF" />, link: '/templates'},
  { name: 'Categories', icon: <CategoryIcon color="#4B5851" />, selectedIcon: <CategoryIcon color="#FFFFFF" />, link: '/categories'},
  { name: 'Sectors', icon: <SectorIcon color="#4B5851" />, selectedIcon: <SectorIcon color="#FFFFFF" />, link: '/sectors'},
  { name: 'Locations', icon: <PrimaryIcon color="#4B5851" />, selectedIcon: <PrimaryIcon color="#FFFFFF" />, link: '/client-bars'},
  { name: 'Upload Tags', icon: <UploadIcon color="#4B5851" />, selectedIcon: <UploadIcon color="#FFFFFF" />, link: '/upload-tags'},
  { name: 'Analytics', icon: <AnalysisIcon color="#4B5851" />, selectedIcon: <AnalysisIcon color="#FFFFFF" />, link: '/analytics'},  
  { name: 'Users', icon: <UsersIcon color="#4B5851" />, selectedIcon: <UsersIcon color="#FFFFFF" />, link: '/users'},
];

export const Sidebar = () => {
  const location = useLocation();
  const { permissions } = useGlobalAtoms();
  const { user } = useAuth();
  const sidebarMenuItems = user?.is_super_admin ? superAdminSidebarMenuItems : clientAdminSidebarMenuItems;

  return (
    <Stack className="sidebar" width='220px' minWidth='220px' height='100vh' borderRight="1px solid #DCDCE0">
      <Stack mt={4} alignItems='center' justifyContent='center'>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <VeribliLogo width={150} height={64} />
        </Link>
      </Stack>
      <Stack mt={2}>
        <ProfileInfo />
        {
          sidebarMenuItems.filter((item: SidebarMenuItemType) => 
            item.link == '/' || (permissions.findIndex((permission, index) => permission.url == item.link) >= 0)
          ).map((item: SidebarMenuItemType, index: number) => {
            const isSelected = item.link === '/' 
              ? item.link === location.pathname 
              : location.pathname.startsWith(item.link);

            return (
              <Link
                className="sidebar-item"
                key={index}
                to={item.link}
                style={{ 
                  cursor: 'pointer', 
                  textDecoration: 'none', 
                  background: isSelected ? '#3E4049' : '#FFFFFF',
                  display: 'block',
                  color: isSelected ? '#FFFFFF' : '#4B5851',
                  padding: '12px 16px',
                }}
              >
                <Stack flexDirection='row' alignItems='center'>
                  <span style={{ minWidth: '25px', textAlign: 'center' }}>
                    { isSelected ? item.selectedIcon : item.icon }
                  </span>
                  <Typography color={isSelected ? '#FFFFFF' : '#4B5851'} ml={1}>{item.name}</Typography>
                </Stack>
              </Link>
            )
          })
        }
      </Stack>
    </Stack>
  )
}